import { useEffect } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { FEATURE_FLAGS } from 'src/shared/constants/featureFlags.constant';

export function AutomationsRedirect({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { featureFlags } = useOrg();

  useEffect(() => {
    if (featureFlags?.has(FEATURE_FLAGS.AUTOMATIONS_V12)) {
      if (pathname.startsWith('/automations')) {
        const flowsPath = pathname.replace('/automations', '/flows');
        navigate({ to: flowsPath, replace: true });
      }
    }
  }, [pathname, navigate, featureFlags]);

  // If feature flag is enabled and we're on an automations route, don't render children
  // (we're redirecting)
  if (featureFlags?.has(FEATURE_FLAGS.AUTOMATIONS_V12) && pathname.startsWith('/automations')) {
    return null;
  }

  return <>{children}</>;
}
